export const BOOKABLE_TYPE = {
    ALWAYS: 'always',
    BUNDLE_OR_SUBSCRIPTION: 'bundles_or_recurring',
    NEVER: 'never',
    NEVER_AND_HIDDEN: 'never_and_hidden',
};

export const BOOKABLE_TYPES_ARRAY = Object.values(BOOKABLE_TYPE);
